<template>
  <section :class="$style.root">
    <div
      class="parts-container"
      :class="[$style.container, { [$style.reverse]: textOrientation === 'left' ? true : false }]"
    >
      <div :class="$style.thumbnail">
        <video
          v-if="pcUrl"
          muted
          playsinline
          :src="pcUrl"
          :autoplay="pcVideoAutoPlay"
          :preload="pcVideoAutoPlay ? 'auto' : 'none'"
          :loop="pcLoopPlayback"
          :controls="pcControls"
          class="page-parts-pc"
        ></video>
        <video
          v-if="spUrl"
          muted
          playsinline
          :src="spUrl"
          :autoplay="spVideoAutoPlay"
          :preload="spVideoAutoPlay ? 'auto' : 'none'"
          :loop="spLoopPlayback"
          :controls="spControls"
          class="page-parts-sp"
        ></video>
      </div>
      <div :class="$style.text_area">
        <p
          :class="[$style.title, fontSize, fontWeight, { 'page-parts-pc': spTitle ? true : false }]"
          v-html="sanitizeHtmlContent(title)"
        ></p>
        <p
          v-if="spTitle"
          class="page-parts-sp"
          :class="[$style.title, fontSize, fontWeight]"
          v-html="sanitizeHtmlContent(spTitle)"
        ></p>
        <p
          :class="[$style.description, descFontSize]"
          class="page-parts-pc"
          v-html="sanitizeHtmlContent(description)"
        ></p>
        <p
          v-if="spDescription"
          class="page-parts-sp"
          :class="[$style.description, descFontSize]"
          v-html="sanitizeHtmlContent(spDescription)"
        ></p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"
type Props = {
  title: string
  spTitle?: string
  description?: string
  spDescription?: string
  fontSize?: string[]
  descFontSize?: string[]
  fontWeight?: string
  pcUrl?: string
  spUrl?: string
  textOrientation?: string
  imgUrlCaption?: string
  spImgUrlCaption?: string
  pcAutoPlay?: boolean
  spAutoPlay?: boolean
  pcLoopPlayback?: boolean
  spLoopPlayback?: boolean
  pcControls?: boolean
  spControls?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
  spTitle: "",
  description: "",
  spDescription: "",
  fontSize: () => [],
  descFontSize: () => [],
  fontWeight: "",
  pcUrl: "",
  spUrl: "",
  textOrientation: "",
  imgUrlCaption: "",
  spImgUrlCaption: "",
  pcAutoPlay: true,
  spAutoPlay: true,
  pcLoopPlayback: true,
  spLoopPlayback: true,
  pcControls: true,
  spControls: true,
})

const pcVideoAutoPlay = ref(false)
const spVideoAutoPlay = ref(false)

if (process.client) {
  if (window.innerWidth >= 768 && props.pcAutoPlay) {
    pcVideoAutoPlay.value = true
  }
  if (window.innerWidth < 768 && props.spAutoPlay) {
    spVideoAutoPlay.value = true
  }
}
</script>

<style scoped module lang="scss">
.root {
  .container {
    display: block;
    align-items: center;
    justify-content: space-between;
    @include container-lg;
    padding: 0;
    @include md {
      display: flex;
      padding: 0 5rem;
    }
    &.reverse {
      flex-direction: row-reverse;
      .thumbnail {
        margin-right: 0;
      }
    }
  }
  .thumbnail {
    width: 100%;
    margin-bottom: 14px;
    border-radius: 7px;
    aspect-ratio: 488 / 288;
    @include md {
      width: 47%;
      margin-bottom: 0;
    }
    video {
      width: 100%;
      object-fit: cover;
    }
  }
  .text_area {
    width: auto;
    padding: 0 2rem;
    @include md {
      width: 47%;
    }
    .title {
      @include main-font;
      padding: 0 5px;
      margin-bottom: 12px;
      font-size: $font-size-18;
      line-height: 1.84;
      @include md {
        padding: 0;
        font-size: $font-size-22;
      }
    }
    .description {
      line-height: 27.6px;
    }
  }
}
</style>
